import { API_BASE_URL } from 'api/config';
import {createAxios} from "./axios";

const heartratesApi = createAxios({
    baseURL: API_BASE_URL + '/heartrates'
});

export const getHeartrates = () => {
    return heartratesApi.get('/');
};